<template>
  <div :class="$style.container">
    <template v-if="!isHost">
      <div :class="[$style.itemContainer, $style.playerItemContainer]">
        <img :class="$style.itemIcon" :src="starIcon" alt="star" />
        <div :class="$style.itemTextContainer">
          <div :class="$style.itemText">{{ player?.score ?? "--" }}</div>
          <div :class="$style.itemLabel">{{ $t('score') }}</div>
        </div>
      </div>
      <div :class="[$style.itemContainer, $style.playerItemContainer]">
        <img :class="$style.itemIcon" :src="trophyIcon" alt="trophy" />
        <div :class="$style.itemTextContainer">
          <div :class="$style.itemText">{{ player?.position ?? "--" }}</div>
          <div :class="$style.itemLabel">{{ $t('position') }}</div>
        </div>
      </div>
    </template>
    <template v-if="isHost">
      <div :class="[$style.itemContainer, $style.hostItemContainer]">
        <div :class="$style.itemTextContainer">
          <div :class="$style.itemText">{{ topScorer?.username ?? "--" }}</div>
          <div :class="$style.itemLabel">{{ $t('game-winner') }}</div>
        </div>
      </div>
      <div :class="[$style.itemContainer, $style.hostItemContainer]">
        <div :class="$style.itemTextContainer">
          <div :class="$style.itemText">{{ topScorer?.score ?? "--" }}</div>
          <div :class="$style.itemLabel">Highscore</div>
        </div>
      </div>
    </template>
    <div :class="$style.itemContainer">
      <div :class="$style.itemTextContainer">
        <div :class="$style.itemText">{{ realTextLabel ?? "--" }}</div>
        <div :class="$style.itemLabel">{{ $t('correct-text') }}</div>
      </div>
    </div>
    <div :class="$style.itemContainer">
      <div :class="$style.itemTextContainer">
        <div :class="$style.itemText">{{ saboteur?.name ?? "--" }}</div>
        <div :class="$style.itemLabel">{{ $t('saboteur') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import styles from "@/css/TopResultsBox.module.css";
import StarIcon from "@/assets/icons/star.svg";
import TrophyIcon from "@/assets/icons/trophy.svg";

export default {
  components: {},
  name: "TopResultsBox",
  props: {
    saboteur: {
      type: Object,
      required: false,
      default: () => {},
    },
    topScorer: {
      type: Object,
      required: false,
      default: () => {},
    },
    player: {
      type: Object,
      required: true,
      default: () => {},
    },
    isHost: {
      type: Boolean,
      required: true,
      default: false,
    },
    realTextLabel: {
      type: String,
      required: true,
      default: "",
    },
  },
  data() {
    return {
      starIcon: StarIcon,
      trophyIcon: TrophyIcon,
    };
  },
  computed: {
    $style() {
      return styles;
    },
  },
  methods: {},
  mounted() {
    // console.log("saboteur: ", this.saboteur);
    // console.log("topScorer: ", this.topScorer);
    // console.log("isHost: ", this.isHost);
    // console.log("player: ", this.player);
    // console.log("realTextLabel: ", this.realTextLabel);
  },
  beforeUnmount() {},
  watch: {},
};
</script>

<style scoped></style>
